import {useEffect} from 'react';
import type {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {useAppSelector} from 'src/redux/hooks';
import {useLocalStorage} from 'usehooks-ts';

const useActiveFeatureFlags = (): FeatureFlagEnum[] => {
  const {session} = useAppSelector(state => state.session);
  const activeInstance = session?.instance;
  const [cache, setCache] = useLocalStorage<FeatureFlagEnum[]>(
    'active_feature_flags',
    []
  );

  useEffect(() => {
    if (
      activeInstance &&
      activeInstance.activeFeatures &&
      JSON.stringify(cache) !== JSON.stringify(activeInstance.activeFeatures)
    ) {
      setCache(activeInstance.activeFeatures);
    }
  }, [activeInstance]);

  return activeInstance?.activeFeatures ?? cache;
};

export default useActiveFeatureFlags;
